import { TagTitleSection } from "../elements/TagTitleSection"
import "../styles/sections/ourtecnology.styles.css"
import img from "../assets/Pré-Moldados-V21.webp"
import { FaCheckCircle } from "react-icons/fa";

export const OurComp = () => {
    return (
        <section id="our-comp" className="our-tecnology-section">
            <TagTitleSection title="Nossa Equipe" />
            <div className="content-tecnology our-comp">
                <div className="tec-img-box">
                    <img src={img} alt="Imagem sobre tecnologia" width={700} height={500} />
                </div>
                <div className="tec-content-box">
                    <div className="tec-content">
                        <span>
                            <FaCheckCircle />
                        </span>
                        <div className="tec-content-texts">
                            <p className="tec-content-texts-title">Atendimento personalizado</p>
                            <p className="tec-content-texts-descrip">Um diferencial significativo da Premold é o prazo de implementação ágil e eficiente. Com métodos de construção inovadores e uma equipe altamente capacitada, a empresa é capaz de entregar os projetos de galpões pré-moldados dentro de prazos rigorosos, sem comprometer a qualidade.</p>
                        </div>
                    </div>
                    <div className="tec-content">
                        <span>
                            <FaCheckCircle />
                        </span>
                        <div className="tec-content-texts">
                            <p className="tec-content-texts-title">Segurança e Qualidade</p>
                            <p className="tec-content-texts-descrip">A segurança e qualidade dos colaboradores e clientes são prioridades absolutas. A empresa investe em treinamentos regulares e práticas de segurança rigorosas para garantir um ambiente de trabalho seguro e saudável para sua equipe.</p>
                        </div>
                    </div>
                    <div className="tec-content">
                        <span>
                            <FaCheckCircle />
                        </span>
                        <div className="tec-content-texts">
                            <p className="tec-content-texts-title">Prazo confortável</p>
                            <p className="tec-content-texts-descrip">Entendemos a importância dos prazos para os nossos clientes. Por isso, nos comprometemos a entregar cada projeto dentro do prazo estabelecido, sem comprometer a qualidade.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}